import { State } from "@/state";

import { COMMAND_ID as CONNECT_STRIPE_ACCOUNT_COMMAND_ID } from "./ConnectStripeAccountCommand";
import { COMMAND_ID as NEW_RULE_COMMAND_ID } from "./NewRuleCommand";

/** Open the new-rule dialog (template picker or from scratch). */
export function openNewRuleFlow() {
  State.getState().pushToCommandStack({
    commandDefinitionId: NEW_RULE_COMMAND_ID,
  });
}

/**
 * Open the Stripe Connect OAuth flow.
 *
 * The command components only mount inside the app layout, so a page outside
 * it (the public invoice page) cannot push this itself — it links to
 * ``/app?connect=stripe`` and the app calls this on arrival.
 */
export function openConnectStripeFlow() {
  State.getState().pushToCommandStack({
    commandDefinitionId: CONNECT_STRIPE_ACCOUNT_COMMAND_ID,
  });
}

/**
 * Open the "Upload transactions" wizard.
 *
 * Two-step command flow: first push the financial-account picker, and
 * on submit replace it with the upload dialog. We pop the picker before
 * pushing the upload command so the back arrow on the upload dialog
 * dismisses the whole flow rather than returning to the picker — this
 * mirrors the wizard pattern already used by ``ConnectBankAccountCommand``.
 *
 * Used by both ``TransactionsView/Subnav`` and
 * ``FinancialAccountsView/Subnav`` so the entry-point UX is identical
 * regardless of which list the user happens to be browsing. The
 * default picker filter (defined on ``SelectFinancialAccountCommand``)
 * already restricts the list to bank accounts (not Stripe), matching the
 * eligibility gate on the per-card "Upload transactions" action.
 */
export function openUploadToFinancialAccountFlow() {
  const state = State.getState();
  state.pushToCommandStack({
    commandDefinitionId: "select-financial-account",
    context: {
      onSubmit: (account) => {
        const next = State.getState();
        next.popCommandsFromStack();
        next.pushToCommandStack({
          commandDefinitionId: "upload-to-financial-account",
          context: {
            financialAccountIdentifier: account.identifier,
            accountName: account?.name ?? null,
          },
        });
      },
    },
  });
}
